import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import {
  useCreateMasivo,
  useCreateMasivoConArchivos,
} from '@/shared/actions/erp/tickets-soporte-cliente/gestion-tickets-masivos.actions';
import FormMasivo, { FormMasivoValues } from '../components/FormMasivo';

const returnUrl = '/tickets-soporte-cliente/masivos';

const CrearMasivoPage: React.FC = () => {
  const navigate = useNavigate();

  const createMasivoMutation = useCreateMasivo({
    navigate,
    returnUrl,
    enableRedirect: true,
  });
  const createConArchivosMutation = useCreateMasivoConArchivos({
    navigate,
    returnUrl,
    enableRedirect: true,
  });

  const handleSubmit = (data: FormMasivoValues, archivos: File[]) => {
    // El backend acepta multi-seleccion por nivel: enviamos siempre las
    // listas (vacias cuando el nivel no las requiera). Los campos
    // singulares legacy se dejan vacios/null — los masivos nuevos usan
    // exclusivamente las listas.
    const payload: Record<string, unknown> = {
      descripcion: data.descripcion,
      nivel_afectacion: data.nivel_afectacion,
      olts_afectadas: data.olts_afectadas,
      troncales_afectadas: data.troncales_afectadas,
      naps_afectadas: data.naps_afectadas,
      routers_afectados: data.routers_afectados,
      // Clasificacion (coinciden con @Transient JsonProperty del backend)
      tipo_id: data.tipo_id || null,
      categoria_id: data.categoria_id || null,
      subcategoria_id: data.subcategoria_id || null,
      // Flag de afectacion real / falsa alarma
      tiene_afectacion: data.tiene_afectacion,
    };

    if (archivos.length > 0) {
      createConArchivosMutation.mutate({ data: payload, archivos });
    } else {
      createMasivoMutation.mutate(payload);
    }
  };

  const isLoading =
    createMasivoMutation.isPending || createConArchivosMutation.isPending;

  return (
    <Paper elevation={2} sx={{ padding: 3, mb: 2, borderRadius: 2 }}>
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(returnUrl)}
        >
          Cancelar
        </Button>
        <Typography variant="h4">CREAR CASO MASIVO</Typography>
      </Box>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <FormMasivo
            onSubmit={handleSubmit}
            isLoading={isLoading}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CrearMasivoPage;
